/***
*
*   SEARCH
*   Search input field
*
*   PROPS
*   throttle: throttle the callback execution in ms
*   callback: function executed on change and submit
*
**********/

import React, { useState, useEffect } from 'react';
import ClassNames from 'classnames';
import Style from './filter.module.scss';
import { Card, Checkbox } from 'components/lib';

export function Filter(props){

  const [value, setValue] = useState(props.value || '');
  const [typing, setTyping] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const css = ClassNames([ Style.search, props.className ]);

  useEffect(() => {

    // throttle typing
    if (props.throttle && !typing){
      const onKeyPress = () => {

        setTyping(true);
        setTimeout(() => { setTyping(false) }, props.throttle);

      }

      window.addEventListener('keydown', onKeyPress);
      return () => window.removeEventListener('keydown', onKeyPress);
      
    }
  }, [props.throttle, typing]);

  useEffect(() => {

    // callback when typing throttle done
    if (props.throttle && !typing)
      props.callback(value);

  }, [props, typing, value])

  return (
    <form className={ css }>
      <div
        className={ Style.btn }
        onClick={ e => {

          setShowFields(!showFields);

        }}
      />
      {showFields && 
        <Card className={ Style.border } >
          {props?.filterCheck?.map((val, index) => {
            return <Checkbox name={val.name} checked={val.checked} option={val.option} callback={props.checkFields} index={index}/>
          })}
        </Card> 
      }
      <span 
        className={ Style.text }
        onClick={ e => {
          setShowFields(!showFields);
        }}
      >Filtrar</span>
    </form>
  );
}
